import {
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    // Params,
  } from '@angular/router';
// import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';

import { RouterStateSerializer } from '@ngrx/router-store';

import { RouterStateUrl } from './router.state';
import { Injectable } from '@angular/core';

// export interface RouterStateUrl {
//   url: string;
//   queryParams: Params;
//   params: Params;
// }

// export interface RouterState {
//   routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
// }

// export const reducers: ActionReducerMap<RouterState> = {
//   routerReducer: fromRouter.routerReducer,
// };

@Injectable()
export class CustomSerializer implements RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;

    return { url, queryParams, params };
  }
}
